<template>
  <div>
    <h3>General description</h3>
    <p>
      The evasive maneuver mission design different scenario of evasive
      maneuvers given a previously detected risk of conjunction. Given two space
      objects, the chaser and the target, along with their orbits in orbital elements or TLE format.
    <h3>Hypotheses</h3>
    <p>The underlying assumptions for this module are the following:</p>
    <ul>
      <li>The propagation is performed via analytical Keplerian propagator</li>
      <li>The evasive maneuver is performed with 1 burn.</li>
      <li>
        The TLEs or orbital elements given by the user should denote a conjunction within a 7 days
        time span from the latest TLE.
      </li>
    </ul>
    <br />
    <h3>Additional features</h3>
    <ul>
      <li>
        The evaluation of the chaser reaction maneuver scenario and the
        associated ΔV.
      </li>
      <li>
        The computation of a return maneuver to respect a maximum service loss duration.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipEvasiveManeuverMission'
}
</script>
